import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './theme/tokens.css'
import { App } from './app.tsx'
import { applySuperadminFromUrl } from './lib/superadmin.ts'

// Before the first render, so a pass rate is never drawn and then removed.
applySuperadminFromUrl()

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
